import { jsx } from "react/jsx-runtime";
import { forwardRef } from "react";
import RSwitch from "react-switch";
import { useThemeFromContext } from "./theme.js";
const SwitchLabel = (props) => {
  const { children, isOn } = props;
  return jsx("div", { style: {
    display: "flex",
    justifyContent: isOn ? "flex-start" : "flex-end",
    fontSize: 15,
    fontWeight: "bold",
    color: "white",
    height: "100%",
    lineHeight: "28px",
    ...isOn ? { marginLeft: "0.75rem" } : { marginRight: "0.5rem" }
  }, children });
};
const Switch = forwardRef((props, ref) => {
  const { offLabel = "False", onLabel = "True", onChange, ...otherProps } = props;
  const { colors } = useThemeFromContext();
  return jsx(
    RSwitch,
    {
      // Forward ref to underlying input element instead of RSwitch instance.
      ref: (rSwitch) => {
        const inputEl = rSwitch ? rSwitch.$inputRef : null;
        if (ref && "current" in ref) {
          ref.current = inputEl;
        } else if (typeof ref === "function") {
          ref(inputEl);
        }
      },
      onColor: colors.success(1.5),
      offColor: colors.dark(0.8),
      checkedIcon: jsx(SwitchLabel, { isOn: true, children: onLabel }),
      uncheckedIcon: jsx(SwitchLabel, { isOn: false, children: offLabel }),
      width: 80,
      onChange: (checked) => onChange(checked),
      ...otherProps
    }
  );
});
Switch.displayName = "Switch";
export {
  Switch
};
